"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.gridWithDigitalHig = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Grid = _interopRequireDefault(require("@mui/material/Grid"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Makes a Digital HIG grid component using the provided MUIGrid as base
 */
var gridWithDigitalHig = function gridWithDigitalHig(BaseMuiGrid) {
  var Grid = function Grid(_ref) {
    var children = _ref.children,
        container = _ref.container,
        otherProps = _objectWithoutProperties(_ref, ["children", "container"]);

    // https://mui.com/api/grid/
    // List out complete MUI API props and fillout values for props that will be
    // preset in the component; all the others will be received from the parent
    var muiGridApiPresets = _objectSpread({}, container ? {
      // children
      // columnSpacing
      // direction
      // wrap
      // zeroMinWidth
      // rowSpacing
      container: container,
      columns: _constants.columns,
      // DHIG grid is 12 columns wide according to the spec here: https://digital-hig.autodesk.com/grid/
      spacing: _constants.spacing // DHIG grid has standard gutter sizes at various breakpoints according to the spec here: https://digital-hig.autodesk.com/grid/

    } : {// item
      // xl
      // lg
      // md
      // sm
      // xs
      // sx
    });

    return /*#__PURE__*/_react.default.createElement(BaseMuiGrid, _extends({}, otherProps, muiGridApiPresets), children);
  };

  Grid.propTypes = {
    container: _propTypes.default.bool,
    children: _propTypes.default.node.isRequired
  };
  return Grid;
};

exports.gridWithDigitalHig = gridWithDigitalHig;
var Grid = gridWithDigitalHig(_Grid.default);
var _default = Grid;
exports.default = _default;